import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'preflatText'
})
export class PreLoginFlatTextPipe implements PipeTransform {

  transform(value: string, ...args: unknown[]): unknown {

    if(value && value.length){
      return value.split('_').join(' ')
    }

    return value;
  }

}
